import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Add JWT token to every protected request
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) {
    req.headers.Authorization = token; 
    // or: `Bearer ${token}` if your backend expects Bearer
  }
  return req;
});

export default API;
